export default function KeyTermsSection() {
  const terms = [
    { label: "Term", value: "5 Years" },
    { label: "Target Income", value: "10.00% per annum" },
    { label: "Payment Frequency", value: "Monthly" },
    { label: "Asset Class", value: "UK Assisted Living / Social Housing" },
    { label: "Capital Return", value: "At maturity, subject to underlying performance" },
    { label: "Rollover Option", value: "Available at maturity (subject to terms)" },
    { label: "Lease Structure", value: "Full Repair & Insurance (FRI)" },
    { label: "Rent Increases", value: "Index-linked (CPI + 1%)" },
    { label: "Security", value: "First legal charges over properties" },
    { label: "Security Trustee", value: "Independent — holds security on behalf of investors" },
    { label: "Void Periods", value: "None — assured rental income" },
    { label: "Regulation", value: "Section 21 FSMA 2000 financial promotion" },
  ];

  const objectives = [
    { icon: "ri-coin-line", text: "Stable monthly income" },
    { icon: "ri-building-2-line", text: "Exposure to asset-backed social housing" },
    { icon: "ri-trending-up-line", text: "Inflation-linked rental growth potential (CPI + 1%)" },
    { icon: "ri-time-line", text: "Long-term contracted cash flows (up to 25 years)" },
  ];

  return (
    <section className="bg-white py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14">
          {/* Key Terms Table */}
          <div>
            <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest block mb-4">
              Product Summary
            </span>
            <h2
              className="text-2xl md:text-3xl font-bold text-[#071A2E] mb-8"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Key Terms
            </h2>
            <div className="rounded-2xl overflow-hidden border border-slate-100">
              {terms.map((t, i) => (
                <div
                  key={t.label}
                  className={`flex items-start justify-between gap-4 px-5 py-4 ${
                    i % 2 === 0 ? "bg-[#EEF2F9]" : "bg-white"
                  }`}
                >
                  <span className="text-slate-500 text-xs font-medium flex-shrink-0 w-40">{t.label}</span>
                  <span className="text-[#071A2E] text-xs font-semibold text-right">{t.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Investment Objective */}
          <div>
            <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest block mb-4">
              Why Invest
            </span>
            <h2
              className="text-2xl md:text-3xl font-bold text-[#071A2E] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Investment Objective
            </h2>
            <p className="text-slate-500 text-sm leading-relaxed mb-8">
              The Thorpe Dellow Social Housing Structured Product is designed to provide investors with stable, predictable income from a socially impactful, asset-backed investment. The product targets a 10.00% per annum return, paid monthly, from long-term lease agreements with a UK-based housing association operating assisted living properties.
            </p>

            <div className="flex flex-col gap-4 mb-8">
              {objectives.map((o) => (
                <div key={o.text} className="flex items-center gap-3 bg-[#EEF2F9] rounded-xl px-5 py-4">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#C9A84C]/15 text-[#C9A84C] flex-shrink-0">
                    <i className={`${o.icon} text-sm leading-none`} />
                  </div>
                  <span className="text-[#071A2E] text-sm font-medium">{o.text}</span>
                </div>
              ))}
            </div>

            <div className="bg-[#071A2E] rounded-2xl p-6">
              <p className="text-slate-300 text-xs leading-relaxed">
                <strong className="text-[#C9A84C]">Important Notice:</strong> This investment is intended solely for Certified High Net Worth Individuals, Self-Certified Sophisticated Investors, or eligible retail investors subject to appropriateness assessment. Investments involve risk. Capital may be at risk.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
